










import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { debounce } from 'lodash';
@Component({
	components: {},
})
export default class extends Vue {
	@Prop({ default: () => ({}) }) public item!: any;
	@Prop({ default: () => ({}) }) public form!: any;
	private newInputMin = debounce(this.inputMin, 300);
	private newInputMax = debounce(this.inputMax, 300);
	private minFilterValue = null;
	private maxFilterValue = null;
	private inputMin(value) {
		if (value === undefined) {
			this.form.minFilterValue = null;
		} else {
			this.form.minFilterValue = value.target.value;
		}
		this.$emit('change');
	}
	private inputMax(value) {
		if (value === undefined) {
			this.form.maxFilterValue = null;
		} else {
			this.form.maxFilterValue = value.target.value;
		}
		this.$emit('change');
	}
	@Watch('$route.params.viewId')
	private ChildChanged() {
		this.minFilterValue = null;
		this.maxFilterValue = null;
	}
}
